module.exports = __webpack_public_path__ + "static/media/project-4.8e121dd0.jpg";